import styled, { css } from "styled-components";
import * as sc from "../Loader/styles";

export const BookButton = styled.button`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;

  background-color: #1e22ff;
  border-radius: 5px;
  border: 1px solid #1e22ff;
  color: white;
  cursor: pointer;
  font-family: "Rubik", sans-serif;
  font-weight: 500;
  font-size: 16px;
  height: 50px;
  line-height: 1.5;
  width: 160px;

  ${(props) =>
    props.isLoading
      ? css`
          padding: 0;
        `
      : css`
          padding: 16px;
          transition: all 0.2s;
        `}

  :hover {
    color: #1e22ff;
    border: 1px solid #1e22ff;
    background-color: transparent;

    > ${sc.Loader} > path {
      fill: #1e22ff;
    }
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
